export function getElementTransformPositions(element: HTMLElement): { x: number; y: number } {
    const style = window.getComputedStyle(element)
    const matrix = new DOMMatrixReadOnly(style.transform)
    return {
        x: matrix.m41,
        y: matrix.m42,
    }
}
